import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "watchlist-context__name" };
const _hoisted_2 = { class: "watchlist-context__count" };
const _hoisted_3 = { class: "watchlist-context__selection" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "watchlist-context__name" };
const _hoisted_6 = { class: "watchlist-context__count" };
const _hoisted_7 = ["title", "onClick"];
const _hoisted_8 = { class: "watchlist-context__user" };
const _hoisted_9 = {
    key: 0,
    class: "watchlist-context__items"
};
const _hoisted_10 = { class: "watchlist-context__items-title" };
const _hoisted_11 = { class: "watchlist-context__item-image" };
const _hoisted_12 = ["src"];
const _hoisted_13 = { class: "watchlist-context__item-content" };
const _hoisted_14 = { class: "watchlist-context__item-sku" };
const _hoisted_15 = { class: "watchlist-context__item-product" };
import { onMounted, onUnmounted, ref, watch } from 'vue';
import customers from '@astina/paloma-shop-common-ui/src/services/CustomerRepository';
import env from '../services/AppEnv';
import events from '@astina/paloma-common-ui/src/services/EventBus';
import trans from '@astina/paloma-common-ui/src/services/Translator';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import AppDropdown from "@astina/paloma-common-ui/src/components/AppDropdown.vue";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import { activateWatchlist } from "../commands/ActivateWatchlist";
import { isGranted } from "@astina/paloma-common-ui/src/services/AccessManager";
import sidebarContext, { SIDEBAR_STATE_CHANGED } from '../services/AppSidebarContext';
import ModalForm from "@astina/paloma-common-ui/src/components/ModalForm.vue";
import WatchlistImportReportModal from "./WatchlistImportReportModal.vue";
import { saveWatchlist } from "../commands/SaveWatchlist";
import ExportWatchlists from "../commands/ExportWatchlists";
import { importWatchlists } from "../commands/ImportWatchlists";
import productUtils from "@astina/paloma-shop-common-ui/src/services/ProductUtils";
import ValidationUtils from "@astina/paloma-common-ui/src/services/ValidationUtils";
import config from "../services/PortalConfig";
export default /*@__PURE__*/ _defineComponent({
    __name: 'WatchlistContext',
    setup(__props) {
        const watchlists = ref([]);
        const watchlist = ref(null);
        const watchlistSidebarOpen = ref(false);
        const loading = ref(false);
        const showCreateForm = ref(false);
        const createForm = ref(null);
        const watchlistDraft = ref({ name: '', type: 'manual' });
        const exportWatchlists = ref(null);
        const showImportForm = ref(false);
        const importForm = ref(null);
        const importing = ref(false);
        const importDraft = ref({ file: null });
        const importReport = ref(null);
        const addedItems = ref([]);
        const addedItemsTimeout = ref(null);
        const validation = ref(ValidationUtils.emptyValidation());
        const sharingEnabled = ref(config.watchlistsSharingEnabled);
        onMounted(() => {
            loadWatchlists();
            customers.getWatchlistCreateForm().then(form => createForm.value = form);
            if (isGranted('PORTAL_WATCHLISTS_VIEW')) {
                exportWatchlists.value = new ExportWatchlists();
            }
            sidebarContext.$on(SIDEBAR_STATE_CHANGED, () => {
                watchlistSidebarOpen.value = sidebarContext.isWatchlistSidebarOpen();
            });
            events.$on('command.delete_watchlist.success', onWatchlistDelete);
            events.$on('command.save_watchlist.success', onWatchlistUpdate);
            events.$on('command.import_watchlists.success', loadWatchlists);
            events.$on('command.add_watchlist_items.success', onItemsChanged);
            events.$on('watchlists.open', selectWatchlistAndOpenSidebar);
            events.$on('watchlists.open-share', selectWatchlistAndOpenSidebarWithShare);
            events.$on('watchlists.open-create-form', openCreateForm);
        });
        onUnmounted(() => {
            events.$off('command.delete_watchlist.success', onWatchlistDelete);
            events.$off('command.save_watchlist.success', onWatchlistUpdate);
            events.$off('command.import_watchlists.success', loadWatchlists);
            events.$off([
                'command.add_watchlist_items.success',
                'command.remove_watchlist_items.success',
            ], onItemsChanged);
            events.$off('watchlists.open', selectWatchlistAndOpenSidebar);
            events.$off('watchlists.open-share', selectWatchlistAndOpenSidebarWithShare);
            events.$off('watchlists.open-create-form', openCreateForm);
        });
        function toggleWatchlistSidebar() {
            sidebarContext.toggleActiveWatchlist();
        }
        function selectWatchlist(watchlistParam) {
            watchlist.value = watchlistParam;
            return activateWatchlist(watchlist.value.watchlistId);
        }
        function selectWatchlistAndOpenSidebar(watchlist, params) {
            selectWatchlist(watchlist)
                .then(() => sidebarContext.openActiveWatchlist(params));
        }
        function selectWatchlistAndOpenSidebarWithShare(watchlist, params) {
            params = { openWatchlistShareSettings: true };
            selectWatchlistAndOpenSidebar(watchlist, params);
        }
        function createWatchlist() {
            saveWatchlist(watchlistDraft.value)
                .then(watchlist => {
                watchlistDraft.value = { name: '', type: 'manual' };
                showCreateForm.value = false;
                loadWatchlists();
                selectWatchlistAndOpenSidebar(watchlist);
            })
                .catch(validationParam => {
                validation.value = validationParam;
            });
        }
        function importWatchlistsLocal() {
            if (!importDraft.value || !importDraft.value.file || importDraft.value.file.length === 0) {
                return;
            }
            const file = importDraft.value.file.item(0);
            importReport.value = null;
            importing.value = true;
            importWatchlists(file)
                .then(report => {
                importDraft.value.file = null;
                showImportForm.value = false;
                importReport.value = report;
            })
                .finally(() => importing.value = false);
        }
        function loadWatchlists() {
            if (!isGranted('PORTAL_WATCHLISTS_VIEW')) {
                return Promise.resolve();
            }
            loading.value = true;
            return customers.listWatchlists()
                .then(data => {
                watchlists.value = data;
                if (watchlists.value.length === 0) {
                    watchlist.value = null;
                    return Promise.resolve();
                }
                if (env.orders.activeWatchlist) {
                    watchlist.value = watchlists.value.find(w => w.watchlistId === env.orders.activeWatchlist)
                        || watchlists.value[0];
                }
                else {
                    watchlist.value = watchlists.value[0];
                }
                if (watchlist.value.watchlistId !== env.orders.activeWatchlist) {
                    return activateWatchlist(watchlist.value.watchlistId);
                }
            })
                .finally(() => {
                loading.value = false;
            });
        }
        function onWatchlistDelete(watchlistId) {
            if (watchlist.value && watchlist.value.watchlistId === watchlistId) {
                watchlist.value = null;
                loadWatchlists();
                sidebarContext.closeWatchlistSidebar();
            }
        }
        function onWatchlistUpdate(watchlistParam) {
            if (watchlist.value && watchlist.value.watchlistId === watchlistParam.watchlistId) {
                watchlist.value = watchlistParam;
            }
        }
        function onItemsChanged(update) {
            if (watchlist.value && update.watchlist.watchlistId === watchlist.value.watchlistId) {
                watchlist.value = {
                    watchlistId: update.watchlist.watchlistId,
                    name: update.watchlist.name,
                    itemCount: update.watchlist.itemCount,
                    type: 'manual',
                };
                addedItems.value = update.addedItems;
                // TODO show UI indicator
                if (addedItemsTimeout.value) {
                    window.clearTimeout(addedItemsTimeout.value);
                }
                addedItemsTimeout.value = window.setTimeout(() => {
                    addedItems.value = [];
                }, 5000);
            }
            else {
                loadWatchlists();
            }
        }
        function itemImageSrc(item) {
            const image = item.image && productUtils.createImage(item.image);
            return image && image.url || '';
        }
        function openCreateForm() {
            showCreateForm.value = true;
        }
        watch(() => showImportForm.value, onShowImportModalFormChange);
        function onShowImportModalFormChange() {
            if (showImportForm.value) {
                importReport.value = null;
                importForm.value = {
                    name: 'excel_import',
                    fields: [
                        {
                            name: 'file',
                            label: trans('watchlist.import_file'),
                            type: 'file',
                            options: {
                                acceptedFiles: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
                            },
                        },
                    ],
                };
            }
            else {
                importForm.value = null;
            }
            importDraft.value = { file: null };
        }
        return (_ctx, _cache) => {
            return (_ctx.$isGranted('PORTAL_WATCHLISTS_VIEW'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["watchlist-context", { 'watchlist-context--active': watchlistSidebarOpen.value }])
                }, [
                    _createElementVNode("div", {
                        class: "watchlist-context__icon",
                        onClick: _cache[0] || (_cache[0] = ($event) => (toggleWatchlistSidebar()))
                    }, [
                        _createVNode(Icon, {
                            name: "watchlist",
                            "icon-style": "light"
                        })
                    ]),
                    _cache[23] || (_cache[23] = _createTextVNode()),
                    _createElementVNode("div", {
                        class: "watchlist-context__content",
                        onClick: _cache[2] || (_cache[2] = ($event) => (toggleWatchlistSidebar()))
                    }, [
                        _createVNode(Spinner, { loading: loading.value }, null, 8, ["loading"]),
                        _cache[11] || (_cache[11] = _createTextVNode()),
                        (!loading.value && watchlist.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_1, _toDisplayString(watchlist.value.name), 1),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('watchlist.items_count', { count: watchlist.value.itemCount })), 1)
                            ], 64))
                            : _createCommentVNode("", true),
                        _cache[12] || (_cache[12] = _createTextVNode()),
                        (!loading.value && !watchlist.value && _ctx.$isGranted('PORTAL_WATCHLISTS_MANAGE'))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (showCreateForm.value = true), ["prevent"])),
                                class: "watchlist-context__name watchlist-context__name--create",
                                href: ""
                            }, _toDisplayString(_ctx.$t('watchlist.create')), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[24] || (_cache[24] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(AppDropdown, {
                            position: "left",
                            "button-style": "link",
                            onSelect: selectWatchlistAndOpenSidebar
                        }, {
                            button: _withCtx(() => [
                                _createVNode(Icon, { name: "caret-down" })
                            ]),
                            menu: _withCtx((props) => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(watchlists.value, (w) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: w.watchlistId,
                                        onClick: ($event) => (props.select(w)),
                                        class: "dropdown__item"
                                    }, [
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(w.name), 1),
                                        _cache[13] || (_cache[13] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('watchlist.items_count', { count: w.itemCount })), 1),
                                        _cache[14] || (_cache[14] = _createTextVNode()),
                                        (sharingEnabled.value && w.shareStatus === 'enabled')
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "watchlist-context__shared",
                                                title: _ctx.$t('watchlist.shared_by', { user: w.sharedBy?.username }),
                                                onClick: _withModifiers(($event) => (props.select(w, { openWatchlistShareSettings: true })), ["prevent", "stop"])
                                            }, [
                                                _createVNode(Icon, { name: "share-square" })
                                            ], 8, _hoisted_7))
                                            : _createCommentVNode("", true),
                                        _cache[15] || (_cache[15] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_8, [
                                            (w.type === 'manual')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(_toDisplayString(w.createdBy ? w.createdBy.name : ''), 1)
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 8, _hoisted_4));
                                }), 128)),
                                _cache[16] || (_cache[16] = _createTextVNode()),
                                (watchlists.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (showCreateForm.value = true), ["prevent"])),
                                        class: "dropdown__item",
                                        href: ""
                                    }, [
                                        _createVNode(Icon, { name: "plus" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('watchlist.create')), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[17] || (_cache[17] = _createTextVNode()),
                                (exportWatchlists.value && watchlists.value.length > 0)
                                    ? (_openBlock(), _createBlock(CommandButton, {
                                        key: 1,
                                        command: exportWatchlists.value,
                                        class: "dropdown__item",
                                        classes: ['button', 'button--link']
                                    }, null, 8, ["command"]))
                                    : _createCommentVNode("", true),
                                _cache[18] || (_cache[18] = _createTextVNode()),
                                _createElementVNode("a", {
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (showImportForm.value = true), ["prevent"])),
                                    class: "dropdown__item",
                                    href: ""
                                }, [
                                    _createVNode(Icon, { name: "upload" }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('watchlist.import')), 1)
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _cache[25] || (_cache[25] = _createTextVNode()),
                    (addedItems.value.length > 0 && !watchlistSidebarOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.$t('watchlist.item_added', { watchlist: watchlist.value?.name })), 1),
                            _cache[22] || (_cache[22] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addedItems.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "watchlist-context__item"
                                }, [
                                    _createElementVNode("div", _hoisted_11, [
                                        (item.image)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: itemImageSrc(item)
                                            }, null, 8, _hoisted_12))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, _toDisplayString(item.quantity) + " " + _toDisplayString(item.unitCode === 'piece' ? '×' : item.unit) + " " + _toDisplayString(item.sku), 1),
                                        _cache[20] || (_cache[20] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1)
                                    ])
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    _cache[26] || (_cache[26] = _createTextVNode()),
                    (showCreateForm.value && createForm.value)
                        ? (_openBlock(), _createBlock(ModalForm, {
                            key: 1,
                            onSubmit: _cache[5] || (_cache[5] = ($event) => (createWatchlist())),
                            onCancel: _cache[6] || (_cache[6] = ($event) => (showCreateForm.value = false)),
                            form: createForm.value,
                            data: watchlistDraft.value,
                            title: _ctx.$t('watchlist.create'),
                            validation: validation.value,
                            "modal-size": "medium"
                        }, null, 8, ["form", "data", "title", "validation"]))
                        : _createCommentVNode("", true),
                    _cache[27] || (_cache[27] = _createTextVNode()),
                    (showImportForm.value && importForm.value && importDraft.value)
                        ? (_openBlock(), _createBlock(ModalForm, {
                            key: 2,
                            onSubmit: _cache[7] || (_cache[7] = ($event) => (importWatchlistsLocal())),
                            onCancel: _cache[8] || (_cache[8] = ($event) => (showImportForm.value = false)),
                            loading: importing.value,
                            form: importForm.value,
                            data: importDraft.value,
                            title: _ctx.$t('watchlist.import'),
                            "modal-size": "medium"
                        }, null, 8, ["loading", "form", "data", "title"]))
                        : _createCommentVNode("", true),
                    _cache[28] || (_cache[28] = _createTextVNode()),
                    (importReport.value)
                        ? (_openBlock(), _createBlock(WatchlistImportReportModal, {
                            key: 3,
                            report: importReport.value,
                            onClose: _cache[9] || (_cache[9] = ($event) => (importReport.value = null))
                        }, null, 8, ["report"]))
                        : _createCommentVNode("", true)
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
